import VISA_LOGO from '../assets/images/card_logos_light/1.png';
import MASTERCARD_LOGO from '../assets/images/card_logos_light/2.png';
import AMERICAN_EXPRESS_LOGO from '../assets/images/card_logos_light/22.png';

export default {
  'visa': VISA_LOGO,
  'mastercard': MASTERCARD_LOGO,
  'american express': AMERICAN_EXPRESS_LOGO
};
